var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.showEditLink ? _c('div', {
    staticClass: "flex flex-col justify-center items-center"
  }, [_vm.imageUrl && _vm.imageUrl !== '' && _vm.supportsObjectFit && !_vm.loading ? _c('img', {
    staticClass: "object-cover",
    class: _vm.size + ' ' + (_vm.isCircleAvatar ? ' rounded-full ' : _vm.specificRounded) + ' ' + (_vm.withBorder ? 'border border-indigo-600 border-opacity-50' : ''),
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e(), _vm._v(" "), _vm.imageUrl && _vm.imageUrl !== '' && !_vm.supportsObjectFit && !_vm.loading ? _c('div', {
    staticClass: "bg-cover",
    class: _vm.size + ' ' + (_vm.isCircleAvatar ? ' rounded-full ' : _vm.specificRounded) + ' ' + (_vm.withBorder ? 'border border-indigo-600 border-opacity-50' : ''),
    style: 'background-image: url(' + _vm.imageUrl + ')'
  }) : _vm._e(), _vm._v(" "), false ? _c('div', {
    staticClass: "h-28"
  }) : _vm._e(), _vm._v(" "), _vm.imageUrl == '' || !_vm.imageUrl || _vm.loading ? _c('icon', {
    class: 'text-indigo-600 ' + _vm.size,
    attrs: {
      "name": "user"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.showEditLink ? _c('div', {
    staticClass: "text-pink-600 italic text-sm cursor-pointer flex flex-col justify-center items-center cursor-camera",
    on: {
      "click": _vm.showPopupModal
    }
  }, [_vm.imageUrl && _vm.imageUrl !== '' && _vm.supportsObjectFit ? _c('img', {
    staticClass: "object-cover",
    class: _vm.size + ' ' + (_vm.isCircleAvatar ? ' rounded-full ' : _vm.specificRounded),
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _vm._e(), _vm._v(" "), _vm.imageUrl && _vm.imageUrl !== '' && !_vm.supportsObjectFit ? _c('div', {
    staticClass: "bg-cover",
    class: _vm.size + ' ' + (_vm.isCircleAvatar ? ' rounded-full ' : _vm.specificRounded),
    style: 'background-image: url(' + _vm.imageUrl + ')'
  }) : _vm._e(), _vm._v(" "), false ? _c('div', {
    staticClass: "h-28"
  }) : _vm._e(), _vm._v(" "), _vm.imageUrl == '' || !_vm.imageUrl ? _c('icon', {
    class: 'text-indigo-600 ' + _vm.size,
    attrs: {
      "name": "user"
    }
  }) : _vm._e(), _vm._v(" "), _vm.showEditLink ? _c('div', {
    staticClass: "text-pink-600 italic text-sm cursor-pointer"
  }, [_vm._v("\n      Changer d'image\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.showEditLink && _vm.popupShown ? _c('profile-picture-modal', {
    staticClass: "cursor-default",
    attrs: {
      "shown": _vm.popupShown,
      "target-object": _vm.objectToEdit,
      "specific-media": _vm.specificMedia,
      "type-profile-picture": _vm.typeProfilePicture
    },
    on: {
      "close": function ($event) {
        _vm.popupShown = false;
      },
      "changeProfileImageToAnotherUser": function (urlPicture) {
        _vm.changeProfileImageToAnotherUser(urlPicture);
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }